import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../lib/axiosClient';
import { applyThemeVars, cacheThemePrefs, readCachedThemePrefs } from '../pages/theme/themeConstants';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

// Dark-Mode aktiviert: respektiert die gespeicherte User-Praeferenz
// (qm8d_theme_prefs / DB) statt Light hart zu erzwingen.
const readInitialDark = () => {
  try {
    const cached = readCachedThemePrefs();
    if (cached && typeof cached.dark_mode === 'boolean') return cached.dark_mode;
  } catch { /* ignore */ }
  return document.documentElement.classList.contains('dark');
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(readInitialDark);

  // Umschalten + persistieren (DB via bestehende User-Preferences-Pipeline)
  const toggleTheme = useCallback(() => {
    setIsDark((prev) => {
      const next = !prev;
      const cached = readCachedThemePrefs() || {};
      const merged = { ...cached, dark_mode: next };
      applyThemeVars({ dark_mode: next });
      cacheThemePrefs(merged);
      axios.put(`${API}/user/preferences`, merged).catch(() => { /* offline-tolerant */ });
      try { window.dispatchEvent(new CustomEvent('qm8d:theme:changed', { detail: { dark_mode: next } })); } catch { /* ignore */ }
      return next;
    });
  }, []);

  const setDark = useCallback((value) => {
    setIsDark(Boolean(value));
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, setDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
